import { DeviceRunState } from '../../enums/device-run-state.enum';

export interface DeviceDepreciationModel {
  id: string;
  deviceId: string;
  deviceName: string;
  depreciationDate: Date; // 录入日期
  currentValue: string; // 设备现值
  depreciationValue: string; // 折旧金额
}
export interface inspectionItem {
  description: string;
  image?: string;
  frequency?:string;
}
export interface DeviceModelModel {
  id?: string;
  name?: string;
  code?: string;
  image?: string;
  typeName?: string;
  description?: string;
  typeId?: string;
  modelName: string;
  deviceName: string;
  attachmentId: string;
  supplierName: string;
  inspectionItems?: inspectionItem[];
  meteringInstrument?: boolean;
  energyType?: string;
}

export interface DeviceProperty {
  id?: string;
  name?: string;
  value?: string;
  order?: number;
  deviceModelId?: string;
}

export interface DeviceModelSpareQueryModel {
  keyword?: string;
  supplierId?: string;
  spareTypeId?: string;
}

export interface DeviceModelComplexModel {
  deviceModelData: DeviceModelModel;
  deviceModelPropertyList?: DeviceModelProperty[];
  deviceModelFileList?: DeviceModelFileModel[];
  deviceModelSpareList?: DeviceModelSpareModel[];
  deviceExpressionList?: DeviceExpressionModel[];
}

export interface DeviceModelSpareModel {
  sparepartId: string;
  name: string;
  description: string;
  sparepartTypeId: string;
  sparepartTypeName: string;
  supplierId: string;
  supplierName: string;
  size: string;
  price: number;
  count: number;
  purchaseTime: Date;
  image: string;
  deviceModelId?: string;
}

export interface DeviceModelFileModel {
  id?: string;
  originalName?: string;
  description?: string;
  attachmentId?: string;
  attachmentName?: string;
  relateId?: string;
}

export interface DeviceModelProperty {
  id?: string;
  name?: string;
  order?: number;
  deviceModelId?: string;
}

export interface DeviceModelQueryModel {
  name: string;
  pageIndex: number;
  pageSize: number;
}

export interface DeviceModel {
  /**
   * 层级路径
   */
  fullName?: string;
  /**
   * 设备ID
   */
  id: string;
  /**
   * 设备名称
   */
  deviceName: string;

  /**
   * 设备参数
  */
  deviceParameter: string;

  /**
   * 绑定的设备参数列表
   */
  deviceParameters: any[];

  /**
   * 序列号
   */
  sequenceNumber: string;
  /**
   * 设备SN
   */
  deviceSN: string;
  /**
   * 描述
   */
  deviceDesc: string;
  /**
   * 二维码
   */
  qrCode: string;
  /**
   * 设备图片
   */
  devicePicture: string;
  /**
   * 设备型号ID
   */
  deviceModelId: string;
  /**
   * 工厂ID
   */
  customerId: string;
  /**
   * 车间ID
   */
  projectId: string;
  /**
   * 区域ID
   */
  logicalGroupId: string;
  /**
   * 自定义属性列表
   */
  properties: DeviceProperty[];

  /**
   * 是否需要手工录入
   */
  needChangeManually: boolean;
  /**
   * @deprecated
   */
  version: string;
  /**
   * @deprecated
   */
  modelId: string;
  /**
   * @deprecated
   */
  deviceNo: string;
  /**
   * @deprecated
   */
  name: string;
  /**
   * @deprecated
   */
  typeName: string;
  /**
   * @deprecated
   */
  financialNo: string;
  /**
   * @deprecated
   */
  modelName: string;
  /**
   * @deprecated
   */
  stateName: string;
  /**
   * @deprecated
   */
  warrantyDueTime: string;
  /**
   * @deprecated
   */
  supplierName: string;
  /**
   * @deprecated
   */
  purchaseDate: string;
  /**
   * @deprecated
   */
  isCorollaryDevice: boolean;
  /**
   * @deprecated
   */
  purchasePrice: number;
  /**
   * @deprecated
   */
  modelSize: number;
  /**
   * @deprecated
   */
  modelNo: string;
  /**
   * @deprecated
   */
  brandName: string;
  /**
   * @deprecated
   */
  serviceLife: string;
  /**
   * @deprecated
   */
  plantName: string;
  /**
   * @deprecated
   */
  sectionName: string;


  deviceModelName?: string; // 设备类型
  // typeId?: string;//设备类型Id
  // typeName?: string;//设备类型
  stateId?: string; // 设备状态
  categoryId?: string; // 设备分类
  categoryName?: string;
  projectName?: string;
  sectionId?: string; // 工艺段
  supplierId?: string; // 供应商
  depreciationList: Array<DeviceDepreciationModel>; // 折旧历史
  scrapTime?: Date; // 设备报废时间
  mqttClientId: string;
  mqttUserName?: string;
  attachmentName?: string;
  inspectionItem: string; // 巡检项
  deviceSn: string; // 设备编码
  deviceType: string; // 设备类型
  deviceLocation: string; // 安装位置
  deviceCategory: string; // 安装位置
  devicePath: string; // 安装位置
  energyType: string; // 能源类型
  loopName: string; // 回路名称
  currentRatio: number; // 电流变比
  voltageRatio: number; // 电压变比
}

export interface DeviceQueryModel {
  deviceId: string;
  name: string;
  deviceNo: string;
  financialNo: string;
  plantId: string;
  typeId: string;
  isCorollaryDevice: boolean;
  categoryId: string;
  modelId: string;
  sectionId: string;
  stateId: string;
  keyword: string;
  pageIndex: number;
}

export interface DevicePropertyKeyValModel {
  id: string;
  deviceId: string;
  deviceModelId: string;
  modelPropertyId: string;
  propertyKey: string;
  propertyVal: string;
}

export interface DeviceBaseResponse {
  statusCode: number;
  message: string;
  data: any;
}

export interface CorollaryDeviceQueryModel {
  corollaryId: string;
  deviceId: string;
  deviceNo: string;
  deviceName: string;
  deviceType: string;
  pageIndex: number;
}

export interface CorollaryDeviceModel {
  corollaryId: string;
  deviceId: string;
  deviceNo: string;
  deviceName: string;
  deviceType: string;
}

export interface DeviceFileModel {
  id: string;
  deviceId: string;
  attachmentFileName: string;
  description: string;
  originalFileName: string;
}

export interface DeviceFileQueryModel {
  deviceId: string;
  pageIndex: number;
}

export interface DeviceAiImage {
  id?: string;
  deviceId?: string;
  trainingStatus?: number;
  attachmentId?: string;
  attachmentName?: string;
}

export interface DeviceTrainingModel {
  deviceId: string;
  deviceName: string;
  deviceAiImages: DeviceAiImage[];
  trainingStatus: number;
  trainingErrorCode: string;
}

export interface ImagePrediction {
  id: string;
  project: string;
  iteration: string;
  created: Date;
  predictions: PredictionModel[];
}

export interface PredictionModel {
  probability: number;
  tagId: string;
  tagName: string;
  deviceName: string;
}

export interface IterationModel {
  trainedAt?: Date;
}

export const orderListTypes = {
  Repair: 'Repair',
  Maintain: 'Maintain'
};
export interface DeviceCostModel {
  no: string;
  date: Date;
  cost: number;
}

export interface DeviceCostModel {
  no: string;
  date: Date;
  cost: number;
}

export interface PredictionModel {
  probability: number;
  tagId: string;
  tagName: string;
  deviceName: string;
}

export interface DeviceAiImage {
  id?: string;
  deviceId?: string;
  trainingStatus?: number;
  attachmentId?: string;
  attachmentName?: string;
}

export interface DeviceTrainingModel {
  deviceId: string;
  deviceName: string;
  deviceAiImages: DeviceAiImage[];
  trainingStatus: number;
  trainingErrorCode: string;
}

export interface ImagePrediction {
  id: string;
  project: string;
  iteration: string;
  created: Date;
  predictions: PredictionModel[];
}

export interface DeviceFileModel {
  id: string;
  deviceId: string;
  attachmentFileName: string;
  description: string;
  originalFileName: string;
}

export interface DeviceFileQueryModel {
  deviceId: string;
  pageIndex: number;
}

export interface DeviceModelModelOld {
  id: string;
  name: string;
  deviceType: string;
  attachmentName: string;
  comment: string;
  attributes: string[];
  inspectionItem?: string;
  standardLimit?: string;
}

export interface DeviceModelQueryModel {
  modelName: string;
  deviceName: string;
  description: string;
  supplierName: string;
  pageIndex: number;
}

export interface DeviceAttributeModel {
  id: string;
  name: string;
  deviceModelId: string;
}

export interface DeviceModelProperty {
  id?: string;
  name?: string;
  order?: number;
  deviceModelId?: string;
}

export interface DeviceModelFileModel {
  id?: string;
  originalName?: string;
  description?: string;
  attachmentId?: string;
  attachmentName?: string;
  relateId?: string;
}

export interface DeviceModelSpareModel {
  sparepartId: string;
  name: string;
  description: string;
  sparepartTypeId: string;
  sparepartTypeName: string;
  supplierId: string;
  supplierName: string;
  size: string;
  price: number;
  count: number;
  purchaseTime: Date;
  image: string;
  deviceModelId?: string;
}

export interface DeviceExpressionModel {
  baseValue: number; // 基础值
  expressionCategory: string; // 表达式分类
  deviceModelId?: string; // 型号id
  ratioItemJson: string; // 表达式明细json数据
}

export interface DeviceExpressionItemModel {
  minValue: number; // 最小值
  maxValue: number; // 最大值
  ratio: string; // 系数或者设备分类
  name: string;
}


export interface DeviceModelSpareQueryModel {
  keyword?: string;
  supplierId?: string;
  spareTypeId?: string;
}

export interface DeviceStateModel {
  id: string;
  name: string;
}

export interface DeviceMonitorModel {
  id: string;
  state: DeviceRunState;
}

export interface DeviceItemModel {
  id?: string;
  sn?: string;
  deviceName?: string;
  deviceSN?: string;
  deviceDesc?: string;
  projectId?: string;
  gatewayId?: string;
  deviceModelId?: string;
  deviceParameterTemplateId?: string;
  deviceAttribute?: any;
  deviceAttributeModel?: any;
}

export interface DevicePropertyOutput {
  DeviceTypePropertyId: string;
  /*总数量 */
  Name?: string;
  Value?: string;
}

export interface DeviceStatusModel extends DeviceItemModel {
  isAlarm?: boolean;
  isOnline?: boolean;
}

export class DeviceMonitorCountModel {
  total: number;
  normal: number;
  fault: number;
  offline: number;
  online: number;
  totalOnline: number;
  onlineRate: string;
  faultRate: string;
  offlineRate: string;
  deviceAlarm: number;
  limitAlarm: number;

  constructor(_normal: number, _fault: number, _offline: number, _online: number, _deviceAlarm: number, _limitAlarm: number) {
    this.normal = _normal;
    this.fault = _fault;
    this.offline = _offline;
    this.online = _online;

    this.totalOnline = this.normal + this.fault + this.online;
    this.total = this.totalOnline + this.offline;
    this.onlineRate = (this.total > 0 ? (this.totalOnline / this.total * 100).toFixed(2) : '0') + '%';
    this.offlineRate = (this.total > 0 ? (this.offline / this.total * 100).toFixed(2) : '0') + '%';
    this.faultRate = (this.total > 0 ? (this.fault / this.total * 100).toFixed(2) : '0') + '%';

    this.deviceAlarm = _deviceAlarm;
    this.limitAlarm = _limitAlarm;
  }
}

export interface DeviceParameterTemplateModel {
  id: string;
  deviceModelId: string;
  deviceModelName: string;
  version: string;
  creator: string;
  creatorName: string;
  creationTime: Date;
  parameters: DeviceParameterModel[];
  points: number;
}

export interface DeviceParameterTemplateQueryModel {
  deviceModelId: string;
  keyword: string;
  pageIndex: number;
  pageSize: number;
  device: string;
  version: string;
  deviceModelIds: string[];
}

export interface DeviceParameterModel {
  id: string;
  name: string;
  parameterName: string;
  parameterDataTypeId: string;
  parameterDataTypeName: string;
  parameterUnitId: string;
  parameterUnitName: string;
  isNumber: boolean;
  deviceParameterTemplateId: string;
  alarms: DeviceParameterAlarmModel[];
  displayName: string;
  parameterType: string;
  isEnableAlarm: boolean;
  upper: number;
  upperCodeId: string;
  upperCodeName: string;
  upperUpper: number;
  upperUpperCodeId: string;
  upperUpperCodeName: string;
  lower: number;
  lowerCodeId: string;
  lowerCodeName: string;
  lowerLower: number;
  lowerLowerCodeId: string;
  lowerLowerCodeName: string;
  unit: string;
  fixedCount?: number;
}

export interface DeviceParameterQueryModel {
  deviceParameterTemplateId: string;
  pageIndex: number;
}

export interface DeviceParameterAlarmModel {
  id: string;
  alarmLevelId: string;
  alarmLevelName: string;
  alarmDefinitionCode: string;
  alarmDefinitionId: string;
  lower?: number;
  upper?: number;
  deviceParameterId: string;
  containLower?: boolean;
  containUpper?: boolean;
}

export interface DeviceParameterAlarmQueryModel {
  deviceParameterId: string;
  pageIndex: number;
}

export interface DeviceParameterTemplateCopyModel {
  copyParameterTemplateId: string;
  deviceModelId: string;
  version: string;
}

export interface SparepartModel {
  id: string;
  name: string;
  description: string;
  sparepartTypeId: string;
  sparepartTypeName: string;
  supplierId: string;
  supplierName: string;
  size: string;
  price: number;
  count: number;
  purchaseTime: Date;
  image: string;
}

export interface SparepartQueryModel {
  keyword: string;
  sparepartTypeId: string;
  supplierId: string;
  minPrice: number;
  maxPrice: number;
  purchaseStartTime: Date;
  purchaseEndTime: Date;
  pageIndex: number;
}

export interface SparepartTypeModel {
  id: string;
  name: string;
  description: string;
  image: string;
}

export interface SparepartTypeQueryModel {
  keyword: string;
  pageIndex: number;
}

export interface SupplierModel {
  id: string;
  code: string;
  name: string;
  contact: string;
  phone: string;
  address: string;

}

export interface SuppilerQueryModel {
  keyword: string;
  pageIndex: number;
}

export interface DefinitionModel {
  id: string;
  name: string;
  code: string;
  levelId: string;
  levelName: string;
  solution: string;
}

export interface DefinitionQueryModel {
  name: string;
  code: string;
  levelId: string;
  pageIndex: number;
}
